    // Function to update the pagination state (for example, after a page change)
    export const handlePaginationEntries = (newStart, newEnd, total) => {
        return {
            start: newStart,
            end: newEnd,
            totalEntries: total,
        };
    };